/* ============================================================
   OSMANLI DOĞAL TAŞ — ENNEAGRAM · ana motor
   Bağımlılıklar: model.js (hesap), olcek.js (maddeler), icerik.js, sembol.js (3B)
   Ürün verisi Liquid'den #odt-en-veri ile gelir (canlı fiyat/stok).
   ============================================================ */
(function () {
  'use strict';

  var kok = document.querySelector('.odt-en');
  if (!kok || !window.ODTEnneagram || !window.ODTEnneagramOlcek || !window.ODTEnneagramIcerik) return;

  var M = window.ODTEnneagram,
      O = window.ODTEnneagramOlcek,
      I = window.ODTEnneagramIcerik,
      S = window.ODTSembol;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function paraFmt(kurus, bicim) {
    var t = kurus / 100;
    return t.toLocaleString('tr-TR', { minimumFractionDigits: t % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' ' + (bicim || 'TL');
  }

  var VERI = {};
  try { VERI = JSON.parse(($('#odt-en-veri') || {}).textContent || '{}'); } catch (e) { VERI = {}; }
  var URUN = VERI.urunler || {}, PARA = VERI.para || 'TL';

  var SAYFA = O.sayfalar(5);
  var D = { ad: '', email: '', cevap: {}, odak: '', sayfa: 0, sonuc: null, testId: '' };

  function yeniId() {
    var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '';
    for (var i = 0; i < 8; i++) r += abc.charAt(Math.floor(Math.random() * abc.length));
    return 'EN-' + r;
  }
  function tipRenkleri() {
    var r = {};
    for (var i = 1; i <= 9; i++) r[i] = I.TIP[i].renk;
    return r;
  }

  /* ---------------------------------------------------------- hizalama
     Temanın yapışkan başlığı kaydırma yönüne göre görünüp kayboluyor ve
     yüksekliği (~72px) hedefi kaydırıyordu; scrollIntoView bunu hesaba katmaz.
     Bu yüzden: başlığın O ANKİ yüksekliğini ölçüp scrollTo ile git, sonraki
     karede yeniden ölçüp kalan farkı ANINDA kapat. İki anlık kaydırma tek
     hareket gibi görünür — "süzülerek kayıyor" hissi oluşmaz. */
  function baslikPayi() {
    var pay = 10;
    var h = document.querySelector('#sticky-header-content') ||
            document.querySelector('.x-container-header') ||
            document.querySelector('header');
    if (h) {
      try {
        var cs = getComputedStyle(h), r = h.getBoundingClientRect();
        if ((cs.position === 'sticky' || cs.position === 'fixed') && r.height > 0 && r.bottom > 0) {
          pay += r.height;
        }
      } catch (e) { }
    }
    return pay;
  }
  function tepeyeOturt(el) {
    if (!el) return;
    var git = function () {
      var fark = el.getBoundingClientRect().top - baslikPayi();
      if (Math.abs(fark) <= 6) return false;
      window.scrollTo(0, Math.max(0, window.pageYOffset + fark));
      return true;
    };
    git();
    requestAnimationFrame(function () { git(); });   /* başlık durumu değiştiyse kapat */
  }

  /* ---------------------------------------------------------- ekran geçişi */
  var ILK = true, sembol = null, merkezKure = null, alan = null, girisSembol = null;
  function ekran(ad) {
    var y = window.pageYOffset;
    $$('.en-screen', kok).forEach(function (n) {
      n.classList.toggle('is-on', n.dataset.screen === ad);
    });
    if (Math.round(window.pageYOffset) !== Math.round(y)) window.scrollTo(0, y);

    /* Ekran değişiminde aktif ekranı tepeye oturt.
       ÖNCE ANINDA, sonra sessiz düzeltme. Tek gecikmeli çağrı denendi ve olmadı:
       kullanıcı ~700ms yanlış konumda bekleyip ardından uzun bir süzülme görüyordu
       (ölçüm: t=27ms'de ekran -1432px, hareket ancak t=780ms'de başlıyor).
       scrollIntoView kullanılıyor çünkü hedefi tarayıcı hesaplar; iki çağrı
       aynı sonucu verdiği için birbiriyle yarışmaz. */
    if (!ILK) {
      requestAnimationFrame(function () { tepeyeOturt($('.en-screen.is-on', kok)); });
    }
    ILK = false;
  }

  /* ---------------------------------------------------------- yıldız tozu */
  (function () {
    var w = $('.en-stars', kok); if (!w) return;
    var n = window.innerWidth < 700 ? 44 : 88, h = '';
    for (var i = 0; i < n; i++) {
      h += '<i style="left:' + (Math.random() * 100).toFixed(2) + '%;top:' + (Math.random() * 100).toFixed(2) +
           '%;--dur:' + (2.6 + Math.random() * 4).toFixed(1) + 's;--del:' + (Math.random() * 5).toFixed(1) + 's"></i>';
    }
    w.innerHTML = h;
  })();

  /* ---------------------------------------------------------- GİRİŞ */
  function girisSembolBasla() {
    var cv = $('#enGirisSembol', kok);
    if (!cv || !S || girisSembol) return;
    girisSembol = S.enneagram(cv, { renkler: tipRenkleri(), anaTip: 0, kanat: 0 });
  }
  girisSembolBasla();

  /* odak sorusu */
  (function () {
    var kap = $('#enOdak', kok); if (!kap) return;
    var s = I.ODAK[0];
    var h = '<span class="en-odak-s">' + esc(s.soru) + '</span><div class="en-odak-row">';
    s.secenek.forEach(function (o) {
      h += '<button type="button" class="en-odak-b" data-v="' + esc(o.v) + '">' + esc(o.d) + '</button>';
    });
    kap.innerHTML = h + '</div>';
    $$('.en-odak-b', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.en-odak-b', kap).forEach(function (x) { x.classList.remove('is-sel'); });
        b.classList.add('is-sel');
        D.odak = b.dataset.v;
      });
    });
  })();

  $('#enBasla', kok).addEventListener('click', function () {
    var ad = $('#enAd', kok).value.trim();
    var soyadEl = $('#enSoyad', kok); var soyad = soyadEl ? (soyadEl.value || '').trim() : '';
    var uyari = $('#enGirisUyari', kok);
    if (ad.length < 2) {
      uyari.textContent = 'Sana nasıl hitap edelim?';
      uyari.hidden = false;
      try { $('#enAd', kok).focus({ preventScroll: true }); } catch (e) { }
      return;
    }
    if (soyad.length < 2) {
      uyari.textContent = 'Soyadını da yazar mısın? (kişiye özel indirim kodun için)';
      uyari.hidden = false;
      try { soyadEl.focus({ preventScroll: true }); } catch (e) { }
      return;
    }
    if (!D.odak) {
      uyari.textContent = 'Hangi konuda fayda görmek istediğini seçer misin?';
      uyari.hidden = false;
      return;
    }
    uyari.hidden = true;
    D.ad = ad; D.soyad = soyad;
    D.email = ($('#enEmail', kok).value || '').trim();
    D.sayfa = 0; D.cevap = {};
    if (girisSembol) { girisSembol.durdur(); girisSembol = null; }
    ekran('soru');
    if (!alan && S) alan = S.alan($('#enAlan', kok), '#3ddad7');
    sayfaCiz();
  });

  /* ---------------------------------------------------------- SORULAR
     Ekran başına 5 madde. 57 maddeyi tek tek sormak yerine blok halinde
     göstermek tamamlanma oranını belirgin artırıyor. */
  function sayfaCiz() {
    var maddeler = SAYFA[D.sayfa], kap = $('#enSoru', kok);
    var toplam = SAYFA.length;
    $('#enIlerlemeCubuk', kok).style.width = Math.round(D.sayfa / toplam * 100) + '%';
    $('#enIlerlemeYazi', kok).textContent = (D.sayfa + 1) + ' / ' + toplam;

    var bolum = D.sayfa < 9 ? 'Kalıpların' : (D.sayfa < 11 ? 'Enerjini nereye veriyorsun' : 'Şu anki dönemin');
    var h = '<div class="en-q-bolum">' + esc(bolum) + '</div>' +
            '<p class="en-q-yon">Her cümle için sana ne kadar uyduğunu işaretle.</p>' +
            '<div class="en-mlist">';

    maddeler.forEach(function (md) {
      var secili = D.cevap[md.id] || 0;
      h += '<div class="en-m" data-id="' + md.id + '">' +
           '<div class="en-m-t">' + esc(md.m) + '</div>' +
           '<div class="en-m-scale" role="group" aria-label="' + esc(md.m) + '">';
      O.LIKERT.forEach(function (l) {
        h += '<button type="button" class="en-dot' + (secili === l.v ? ' is-sel' : '') + '" ' +
             'data-id="' + md.id + '" data-v="' + l.v + '" ' +
             'aria-label="' + esc(l.k) + '"><i></i><em>' + esc(l.k) + '</em></button>';
      });
      h += '</div></div>';
    });
    h += '</div>';
    kap.innerHTML = h;

    $$('.en-dot', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.dataset.id;
        D.cevap[id] = +b.dataset.v;
        $$('.en-dot[data-id="' + id + '"]', kap).forEach(function (x) { x.classList.remove('is-sel'); });
        b.classList.add('is-sel');
        b.closest('.en-m').classList.add('is-done');
        durumGuncelle();
      });
    });
    durumGuncelle();

    var geri = $('#enGeri', kok);
    geri.textContent = D.sayfa === 0 ? '← Başa dön' : '← Geri';
  }

  function durumGuncelle() {
    var maddeler = SAYFA[D.sayfa];
    var eksik = maddeler.filter(function (m) { return !D.cevap[m.id]; }).length;
    var btn = $('#enIleri', kok);
    btn.disabled = eksik > 0;
    btn.textContent = eksik > 0
      ? (eksik + ' madde kaldı')
      : (D.sayfa === SAYFA.length - 1 ? 'Sonucu Gör →' : 'Devam →');
  }

  $('#enIleri', kok).addEventListener('click', function () {
    if ($('#enIleri', kok).disabled) return;
    if (D.sayfa < SAYFA.length - 1) {
      D.sayfa++;
      sayfaCiz();
      /* Yeni blok anında başa otursun; 5 maddelik blokta kullanıcı ortadan
         devam ederse ilk maddeleri kaçırıyor. */
      tepeyeOturt($('.en-ilerleme', kok));
    } else {
      hesapCalistir();
    }
  });
  $('#enGeri', kok).addEventListener('click', function () {
    if (D.sayfa > 0) { D.sayfa--; sayfaCiz(); }
    else { ekran('gate'); girisSembolBasla(); }
  });

  /* ---------------------------------------------------------- HESAP */
  function hesapCalistir() {
    ekran('hesap');
    var p = O.puanla(D.cevap);
    D.sonuc = M.coz(p.ham, p.ham3, p.saglik);
    D.testId = yeniId();

    var adim = $('#enHesapAdim', kok);
    var metin = [
      'Yanıtların normalleştiriliyor…',
      'Dokuz tip karşılaştırılıyor…',
      'Kanadın belirleniyor…',
      'Stres ve büyüme okların çiziliyor…',
      'İçgüdüsel yığının hesaplanıyor…'
    ];
    var mi = 0;
    adim.textContent = metin[0];
    var tik = setInterval(function () {
      mi++;
      if (mi >= metin.length) {
        clearInterval(tik);
        setTimeout(function () {
          if (alan) { alan.durdur(); alan = null; }
          sonucCiz();
          ekran('sonuc');
          panelKaydet();
        }, 400);
        return;
      }
      adim.textContent = metin[mi];
    }, 560);
  }

  /* ---------------------------------------------------------- sepet */
  var CART_SECTIONS = [
    { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    { id: 'mobile-cart-icon-bubble', selector: '#mobile-cart-icon-bubble' },
    { id: 'cart-drawer', selector: '#CartDrawer' }
  ];
  function cartSections() {
    try { var s = Alpine.store('xCartHelper').getSectionsToRender(); if (s && s.length) return s; } catch (e) { }
    return CART_SECTIONS;
  }
  function swapCart(secs, payload) {
    if (!payload) return false;
    var ok = false;
    secs.forEach(function (s) {
      try {
        var e = document.querySelector(s.selector);
        if (e && payload[s.id]) {
          var src = new DOMParser().parseFromString(payload[s.id], 'text/html').querySelector(s.selector);
          if (src) { e.innerHTML = src.innerHTML; ok = true; }
        }
      } catch (err) { }
    });
    return ok;
  }
  function syncCart() {
    try {
      var sp = document.querySelector('#cart-icon-bubble span');
      if (sp) Alpine.store('xCartHelper').currentItemCount = parseInt(sp.textContent) || 0;
    } catch (e) { }
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }
  var etiketYazildi = false;
  function sepetEtiketi() {
    if (etiketYazildi || !D.testId || !D.sonuc) return;
    etiketYazildi = true;
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'Enneagram': D.testId,
        'Tip': String(D.sonuc.anaTip),
        'Kanat': D.sonuc.kanat.etiket
      } })
    }).catch(function () { });
  }
  function sepetBildir(btn) {
    if (!VERI.sepet || !D.testId) return;
    var kart = btn && btn.closest ? btn.closest('.en-p') : null;
    var p = kart ? URUN_HAR[kart.dataset.kid] : null;
    try {
      fetch(VERI.sepet, {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ test_kod: D.testId, urun: p ? p.t : '' })
      }).catch(function () { });
    } catch (e) { }
  }
  function sepeteEkle(vid, btn, eski) {
    btn.disabled = true; btn.textContent = 'EKLENİYOR…';
    var secs = cartSections();
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1,
        sections: secs.map(function (s) { return s.id; }), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.textContent = 'STOKTA YOK';
          setTimeout(function () { btn.textContent = eski; btn.disabled = false; }, 1800);
          return;
        }
        btn.textContent = 'EKLENDİ ✓'; btn.classList.add('is-ok');
        if (res.j && res.j.sections && swapCart(secs, res.j.sections)) syncCart();
        sepetEtiketi(); sepetBildir(btn);
        try { Alpine.store('xMiniCart').openCart(); } catch (e) { }
        setTimeout(function () { btn.textContent = eski; btn.disabled = false; btn.classList.remove('is-ok'); }, 2200);
      }).catch(function () {
        btn.textContent = 'HATA';
        setTimeout(function () { btn.textContent = eski; btn.disabled = false; }, 1800);
      });
  }

  /* ---------------------------------------------------------- ürün kartları */
  var URUN_SAY = 0, URUN_HAR = {};
  function urunler(handle, adet, etiket) {
    var liste = (URUN[handle] || []).slice(0, adet || 4);
    if (!liste.length) return '';
    var h = '<div class="en-products">';
    liste.forEach(function (p) {
      var kid = 'enp' + (++URUN_SAY); URUN_HAR[kid] = p;
      var vs = p.v || [];
      h += '<div class="en-p" data-kid="' + kid + '">' +
           '<a class="en-p-link" href="' + esc(p.u) + '">' +
           '<div class="en-p-img">' +
           (p.g ? '<img src="' + esc(p.g) + '" alt="' + esc(p.t) + '" loading="lazy" width="400" height="400">' : '') +
           (etiket ? '<span class="en-p-tag">' + esc(etiket) + '</span>' : '') + '</div>' +
           '<div class="en-p-title">' + esc(p.t) + '</div>' +
           '<div class="en-p-price">' + (p.k && p.k > p.f ? '<del>' + paraFmt(p.k, PARA) + '</del>' : '') +
           paraFmt(p.f, PARA) + '</div></a>';
      if (vs.length) {
        h += '<button type="button" class="en-add" data-kid="' + kid + '">Sepete Ekle</button>';
        if (vs.length > 1) {
          h += '<div class="en-sizes" hidden><span class="en-sizes-lbl">' + esc(p.o || 'Beden') + ' seçin</span><div class="en-sizes-row">';
          vs.forEach(function (v) {
            h += '<button type="button" class="en-size" data-kid="' + kid + '" data-vid="' + v.i + '">' + esc(v.t) + '</button>';
          });
          h += '</div></div>';
        }
      } else {
        h += '<a class="en-add" href="' + esc(p.u) + '">Ürünü İncele</a>';
      }
      h += '</div>';
    });
    return h + '</div>';
  }
  function urunOlaylari(kap) {
    $$('.en-add[data-kid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = URUN_HAR[b.dataset.kid]; if (!p) return;
        var vs = p.v || [];
        if (vs.length === 1) { sepeteEkle(vs[0].i, b, 'Sepete Ekle'); return; }
        var kutu = b.parentNode.querySelector('.en-sizes');
        if (kutu) { var acik = !kutu.hidden; kutu.hidden = acik; b.textContent = acik ? 'Sepete Ekle' : 'Kapat'; }
      });
    });
    $$('.en-size[data-vid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var kart = b.closest('.en-p'), ana = kart ? kart.querySelector('.en-add') : null;
        $$('.en-size', kart).forEach(function (x) { x.classList.remove('is-picked'); });
        b.classList.add('is-picked');
        sepeteEkle(b.dataset.vid, ana || b, 'Sepete Ekle').then(function () {
          var k = kart ? kart.querySelector('.en-sizes') : null; if (k) k.hidden = true;
        });
      });
    });
  }

  /* ---------------------------------------------------------- panel */
  function kaynakBul() {
    try {
      var q = new URLSearchParams(location.search), u = q.get('utm_source') || q.get('ref');
      if (u) return String(u).slice(0, 60);
      if (!document.referrer) return 'dogrudan';
      var hh = new URL(document.referrer).hostname.replace(/^www\./, '');
      return hh === location.hostname.replace(/^www\./, '') ? 'site-ici' : hh.slice(0, 60);
    } catch (e) { return ''; }
  }
  function panelKaydet() {
    if (!VERI.panel || !D.sonuc) return;
    var s = D.sonuc;
    try {
      fetch(VERI.panel, {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          test_kod: D.testId, tur: 'enneagram',
          ad: D.ad, soyad: D.soyad, email: D.email,
          tip: s.anaTip, kanat: s.kanat.kanat, kanat_kod: s.kanat.etiket,
          merkez: s.merkez.ad, hornevian: s.hornevian.ad, harmonik: s.harmonik.ad,
          stres_ok: s.stresOk, buyume_ok: s.buyumeOk,
          icgudu: s.icgudu.baskin, icgudu_sira: s.icgudu.sira.join(''),
          alt_tip: s.altTipKod, karsi_tip: s.karsiTipMi ? 1 : 0,
          guven: s.guven.seviye, saglik: s.saglik,
          puanlar: s.sirali.reduce(function (a, x) { a[x.tip] = x.yuzde; return a; }, {}),
          odak: D.odak,
          cihaz: window.matchMedia('(max-width:820px)').matches ? 'mobil' : 'masaustu',
          kaynak: kaynakBul()
        })
      }).then(function(r){return r.json();}).then(function(res){ if(res&&res.kupon){ kuponGoster(res.kupon); } }).catch(function () { });
    } catch (e) { }
  }
  function kuponGoster(kod){ if(!kod)return; if(document.getElementById('enKupon'))return;
    var pr=document.querySelector('.en-products'); if(!pr)return;
    var box=document.createElement('div'); box.id='enKupon'; box.className='nh-kupon';
    box.innerHTML='<span class="nh-kupon-et">🎁 Sana Özel Hediye</span>'+
      '<p class="nh-kupon-a">Enneagram tipini keşfettin — <b>tüm sepetine %10 indirim</b>. 1 hafta geçerli · tek kullanımlık · diğer indirimlerle birleşir.</p>'+
      '<div class="nh-kupon-kod"><code>'+esc(kod)+'</code><button type="button" class="nh-kupon-kopya" id="enKuponKopya">Kopyala</button></div>';
    pr.parentNode.insertBefore(box,pr);
    var kb=document.getElementById('enKuponKopya'); if(kb)kb.onclick=function(){ var ok=false; try{ navigator.clipboard.writeText(kod); ok=true; }catch(e){} if(!ok){try{var tmp=document.createElement('textarea');tmp.value=kod;document.body.appendChild(tmp);tmp.select();document.execCommand('copy');tmp.remove();}catch(e2){}} var t=kb.textContent; kb.textContent='✓ Kopyalandı'; kb.classList.add('ok'); setTimeout(function(){kb.textContent=t;kb.classList.remove('ok');},1900); };
  }

  /* ---------------------------------------------------------- sonuç yardımcı */
  function derin(baslik, ic) {
    return '<details class="en-derin"><summary>' + esc(baslik) + '</summary><div class="en-derin-ic">' + ic + '</div></details>';
  }
  function bolum(id, ust, baslik, ic) {
    return '<section class="en-sec" id="' + id + '">' +
           '<div class="en-sec-hd"><span class="en-sec-ust">' + esc(ust) + '</span>' +
           '<h3 class="en-sec-t">' + esc(baslik) + '</h3></div>' + ic + '</section>';
  }
  function bant(saglik) {
    if (saglik == null) return I.BANT.orta;
    if (saglik >= 0.66) return I.BANT.saglikli;
    if (saglik >= 0.34) return I.BANT.orta;
    return I.BANT.zorlanan;
  }

  /* ---------------------------------------------------------- SONUÇ */
  function sonucCiz() {
    var s = D.sonuc, kap = $('#enSonuc', kok);
    var T = I.TIP[s.anaTip];
    var kanatT = I.TIP[s.kanat.kanat];
    var stresT = I.TIP[s.stresOk], buyumeT = I.TIP[s.buyumeOk];
    var bt = bant(s.saglik);

    kok.style.setProperty('--en-tip', T.renk);
    kok.style.setProperty('--en-tip2', T.renk2);

    var h = '';

    /* ---- 1 · kimlik ---- */
    h += '<div class="en-hero">' +
      '<div class="en-hero-kod">' + esc(D.testId) + '</div>' +
      '<div class="en-hero-ad">' + esc(D.ad) + '</div>' +
      '<div class="en-hero-buyuk" style="--r:' + T.renk + ';--r2:' + T.renk2 + '">' +
        '<span class="en-hero-n">' + s.anaTip + '</span>' +
        '<span class="en-hero-sim">' + T.simge + '</span>' +
      '</div>' +
      '<div class="en-hero-ad2">' + esc(T.ad) + '</div>' +
      '<div class="en-hero-kanat">' + esc(s.kanat.etiket) + ' · ' + esc(kanatT.ad) + ' kanadı</div>' +
      '<p class="en-hero-oz">' + esc(T.oz) + '</p>' +
      '<div class="en-hero-rozet">' +
        '<span class="en-rz">' + esc(s.merkez.ad) + ' merkezi</span>' +
        '<span class="en-rz">' + esc(s.hornevian.ad) + '</span>' +
        '<span class="en-rz">' + esc(I.ICGUDU_METIN[s.icgudu.baskin].ad) + '</span>' +
        (s.karsiTipMi ? '<span class="en-rz is-karsi">karşı-tip</span>' : '') +
      '</div>' +
    '</div>';

    /* güven uyarısı — dürüstlük */
    if (s.guven.seviye !== 'net') {
      var ik = I.TIP[s.sirali[1].tip];
      h += '<div class="en-uyari' + (s.guven.seviye === 'belirsiz' ? ' is-guclu' : '') + '">' +
        '<strong>' + (s.guven.seviye === 'belirsiz' ? 'Sonucun kesin değil.' : 'İkinci bir ihtimal var.') + '</strong> ' +
        'Tip ' + s.anaTip + ' (' + esc(T.ad) + ') ile Tip ' + s.sirali[1].tip + ' (' + esc(ik.ad) + ') puanların çok yakın. ' +
        'Enneagram’da tipi <em>davranış</em> değil <em>motivasyon</em> belirler: ikisinin de tanımını oku ve ' +
        '“hangisinin <u>korkusu</u> bana ait?” diye sor. Doğru cevabı testten çok sen bilirsin.' +
      '</div>';
    }

    /* ---- 2 · 3B sembol ---- */
    h += '<div class="en-sembol-wrap">' +
      '<canvas id="enSembol" class="en-sembol" aria-label="Enneagram sembolü"></canvas>' +
      '<div class="en-lgn">' +
        '<span><i style="background:' + T.renk + '"></i> Tipin</span>' +
        '<span><i style="background:' + kanatT.renk + ';opacity:.8"></i> Kanadın</span>' +
        '<span><i class="is-line" style="background:#e05555"></i> Stres oku → ' + s.stresOk + '</span>' +
        '<span><i class="is-line" style="background:#3ddad7"></i> Büyüme oku → ' + s.buyumeOk + '</span>' +
      '</div>' +
      '<p class="en-sembol-not">Sembolün üçgeni 3-6-9, altıgeni 1-4-2-8-5-7 sırasını izler. ' +
      '<span class="en-ipucu">Sürükleyerek çevirebilirsin.</span></p></div>';

    /* ---- 3 · tipin ---- */
    var tipIc = '<p class="en-buyuk-p">' + esc(T.uzun) + '</p>' +
      '<div class="en-ka">' +
        '<div class="en-ka-k"><span>Temel korkun</span><strong>' + esc(T.korku) + '</strong></div>' +
        '<div class="en-ka-k"><span>Temel arzun</span><strong>' + esc(T.arzu) + '</strong></div>' +
      '</div>' +
      '<div class="en-gg">' +
        '<div class="en-gg-k is-guc"><h4>Gücün</h4><ul>' +
          T.guc.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' +
        '<div class="en-gg-k is-golge"><h4>Gölgen</h4><ul>' +
          T.golge.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' +
      '</div>' +
      '<div class="en-ders"><span>Dersin</span><strong>' + esc(T.ders) + '</strong></div>' +
      derin('Tutku ve erdem — Enneagram’ın çekirdeği',
        '<p>Her tipin bir <strong>tutkusu</strong> (otomatik duygusal kalıbı) ve bunun panzehiri olan bir <strong>erdemi</strong> vardır. ' +
        'Senin tutkun <strong>' + esc(T.tutku) + '</strong>: ' + esc(T.tutkuAcik) + '. Erdemin ise <strong>' + esc(T.erdem) + '</strong>.</p>' +
        '<p>' + esc(T.donusum) + '</p>' +
        '<div class="en-satir"><span>Zihinsel sabitlenme</span><b>' + esc(T.sabit) + '</b></div>' +
        '<div class="en-satir"><span>Kutsal fikir</span><b>' + esc(T.kutsal) + '</b></div>' +
        '<p>Bu kavramlar Enneagram’ın manevi geleneğinden gelir; tutku “günah” değil, kişiliğin dünyayı ' +
        'ayakta tutmak için geliştirdiği otomatik stratejidir. Görüldüğü an gücünü kaybetmeye başlar.</p>');
    h += bolum('enTip', 'Tip ' + s.anaTip + ' · ' + T.unvan, T.ad, tipIc);

    /* ---- 4 · kanat ---- */
    var kanatIc = '<p>' + esc(T.kanat[s.kanat.kanat].m) + '</p>' +
      '<div class="en-kanat-durum">Kanat gücü: <strong>' + esc(s.kanat.guc) + '</strong>' +
      (s.kanat.guc === 'dengeli'
        ? ' — iki kanadın da belirgin. Bu, her ikisinin özelliklerini taşıdığın anlamına gelir.'
        : '') + '</div>' +
      derin('Diğer kanadın: ' + esc(T.kanat[s.kanat.digerKanat].ad),
        '<p>' + esc(T.kanat[s.kanat.digerKanat].m) + '</p>' +
        '<p>Kanat, çemberde tipinin <strong>komşusu</strong> olan iki tipten biridir; uzaktaki bir tip kanat olamaz. ' +
        'Kanat tipini değiştirmez, ona bir renk katar. Zamanla diğer kanadına da açılman normaldir.</p>');
    h += bolum('enKanat', 'Renk katan komşun', s.kanat.etiket + ' — ' + T.kanat[s.kanat.kanat].ad.split('—')[1].trim(), kanatIc);

    /* ---- 5 · oklar ---- */
    var okIc = '<div class="en-ok-grid">' +
      '<div class="en-ok is-stres"><div class="en-ok-h"><span>Stres altında</span><b>' + s.anaTip + ' → ' + s.stresOk + '</b></div>' +
        '<p>' + esc(I.OK_STRES[s.anaTip]) + '</p>' +
        '<div class="en-ok-alt">' + esc(stresT.ad) + ' tipinin gölge yüzü</div></div>' +
      '<div class="en-ok is-buyume"><div class="en-ok-h"><span>Büyüdüğünde</span><b>' + s.anaTip + ' → ' + s.buyumeOk + '</b></div>' +
        '<p>' + esc(I.OK_BUYUME[s.anaTip]) + '</p>' +
        '<div class="en-ok-alt">' + esc(buyumeT.ad) + ' tipinin sağlıklı yüzü</div></div>' +
    '</div>' +
      '<div class="en-bant"><span class="en-bant-ad">' + esc(bt.ad) + '</span><p>' + esc(bt.m) + '</p></div>' +
      derin('Oklar nereden geliyor?',
        '<p>Enneagram sembolündeki çizgiler rastgele değil. Altıgen <strong>1-4-2-8-5-7</strong> sırasını izler — ' +
        'bu, 1/7 = 0,142857… işleminin periyodik rakam dizisidir. Üçgen ise <strong>3-6-9</strong>’u birleştirir.</p>' +
        '<p>Stres yönü <strong>1→4→2→8→5→7→1</strong> ve <strong>9→6→3→9</strong>; büyüme yönü bunun tersidir: ' +
        '<strong>1→7→5→8→2→4→1</strong> ve <strong>9→3→6→9</strong>. Yani baskı altında bir tipin ortalama-sağlıksız ' +
        'özelliklerini alırsın, geliştiğinde başka bir tipin sağlıklı özelliklerine açılırsın.</p>' +
        '<p>Bu, tip değiştirdiğin anlamına gelmez. Ana tipin ömür boyu aynı kalır; oklar yalnızca hareket yönlerindir.</p>');
    h += bolum('enOk', 'Hareket yönlerin', 'Stres ve Büyüme Okların', okIc);

    /* ---- 6 · merkez + duruş ---- */
    var mk = I.MERKEZ_METIN[Object.keys(M.MERKEZ).filter(function (k) {
      return M.MERKEZ[k].tipler.indexOf(s.anaTip) > -1; })[0]];
    /* üç merkezin göreli ağırlığı — z-skorlardan */
    var mAgirlik = {};
    Object.keys(M.MERKEZ).forEach(function (k) {
      var t = M.MERKEZ[k].tipler.map(function (x) { return Math.max(0, s.z[x] + 2); });
      mAgirlik[k] = t.reduce(function (a, b) { return a + b; }, 0);
    });
    var mTop = mAgirlik.beden + mAgirlik.kalp + mAgirlik.zihin || 1;

    var merkezIc = '<div class="en-merkez-wrap"><canvas id="enMerkez" class="en-merkez" aria-label="Üç merkez"></canvas></div>' +
      '<p class="en-buyuk-p">' + esc(mk.m) + '</p>' +
      '<div class="en-durus">' +
        '<div class="en-durus-k"><span>Duruşun · ' + esc(s.hornevian.ad) + '</span><p>' +
          esc(I.HORNEVIAN_METIN[Object.keys(M.HORNEVIAN).filter(function (k) {
            return M.HORNEVIAN[k].tipler.indexOf(s.anaTip) > -1; })[0]]) + '</p></div>' +
        '<div class="en-durus-k"><span>Baş etme biçimin · ' + esc(s.harmonik.ad) + '</span><p>' +
          esc(I.HARMONIK_METIN[Object.keys(M.HARMONIK).filter(function (k) {
            return M.HARMONIK[k].tipler.indexOf(s.anaTip) > -1; })[0]]) + '</p></div>' +
      '</div>';
    h += bolum('enMerkezSec', 'Nereden yaşıyorsun', mk.ad + ' — ' + mk.duygu, merkezIc);

    /* ---- 7 · içgüdüsel yığın ---- */
    var ig = s.icgudu;
    var igIc = '<p class="en-giris">İçgüdüsel yığın, enerjini önce nereye verdiğini gösterir. ' +
      'Tipinle birleşince 27 alt tipten birini oluşturur — Enneagram’ın en ayırt edici katmanı budur.</p>' +
      '<div class="en-ig-row">';
    ig.sira.forEach(function (k, i) {
      igIc += '<div class="en-ig' + (i === 0 ? ' is-bas' : '') + '">' +
        '<div class="en-ig-bar"><i style="height:' + Math.max(8, ig.oran[k]) + '%"></i></div>' +
        '<div class="en-ig-ad">' + esc(I.ICGUDU_METIN[k].ad) + '</div>' +
        '<div class="en-ig-yuzde">%' + ig.oran[k] + '</div>' +
        '<div class="en-ig-sira">' + (i === 0 ? 'baskın' : (i === 1 ? 'ikincil' : 'en zayıf')) + '</div>' +
      '</div>';
    });
    igIc += '</div>';
    igIc += '<div class="en-alttip"><h4>' + esc(T.alt[ig.baskin].ad) + '</h4><p>' + esc(T.alt[ig.baskin].m) + '</p>';
    if (s.karsiTipMi) {
      igIc += '<div class="en-karsi"><strong>Sen bir karşı-tipsin.</strong> Bu alt tip, kendi tipinin diğer iki ' +
        'varyantından belirgin şekilde farklı davranır. Temel korkun ve tutkun aynı, ama dışa vurumun ters yönde. ' +
        'Bu yüzden Tip ' + s.anaTip + ' tanımlarını okuduğunda “ben pek öyle değilim” diyebilirsin — ' +
        'tipini yanlış bulmuş olman gerekmez, karşı-tip olman yeter.</div>';
    }
    igIc += '</div>';
    igIc += derin('Diğer iki alt tipin',
      ['sp', 'so', 'sx'].filter(function (k) { return k !== ig.baskin; }).map(function (k) {
        return '<p><strong>' + esc(T.alt[k].ad) + ':</strong> ' + esc(T.alt[k].m) + '</p>';
      }).join('') +
      '<p>Üç içgüdü de sende var; yığın yalnızca hangisine daha çok enerji verdiğini gösterir. ' +
      'En zayıf içgüdün genelde kör noktandır — orada bilinçli çalışmak dengeni belirgin değiştirir.</p>' +
      (ig.net ? '' : '<p><em>Not:</em> baskın ve ikincil içgüdün birbirine çok yakın çıktı; bu ikisi arasında gidip geliyor olabilirsin.</p>'));
    h += bolum('enIg', 'Enerjini nereye veriyorsun', I.ICGUDU_METIN[ig.baskin].ad + ' baskın', igIc);

    /* ---- 8 · odak alanı ---- */
    var odakBaslik = { benlik: 'Kendini Tanımak', iliski: 'İlişkilerin', is: 'İş ve Kariyer', stres: 'Stresle Başa Çıkmak' };
    var odakMetin = D.odak === 'iliski' ? T.iliskide
                  : D.odak === 'is' ? T.isde
                  : D.odak === 'stres' ? (I.OK_STRES[s.anaTip] + ' ' + T.donusum)
                  : T.donusum;
    h += bolum('enOdak', 'Sorduğun alan', odakBaslik[D.odak] || 'Kendini Tanımak',
      '<p class="en-buyuk-p">' + esc(odakMetin) + '</p>' +
      (D.odak === 'stres'
        ? '<p>Bu döngüyü kırmanın yolu stres okunla savaşmak değil, büyüme okuna bilinçli adım atmak: ' +
          esc(I.OK_BUYUME[s.anaTip]) + '</p>'
        : ''));

    /* ---- 9 · dokuz tip dağılımı ---- */
    var dagIc = '<p class="en-giris">Tipin en yüksek çıkan eğilimin. Diğerlerini de görmek işine yarar: ' +
      'ikinci ve üçüncü sıradakiler genelde kanadın, oklarının ya da alt tipinin etkisidir.</p><div class="en-dag">';
    s.sirali.forEach(function (x, i) {
      var tt = I.TIP[x.tip];
      dagIc += '<div class="en-dag-s' + (i === 0 ? ' is-bas' : '') + '">' +
        '<span class="en-dag-n" style="--r:' + tt.renk + '">' + x.tip + '</span>' +
        '<span class="en-dag-ad">' + esc(tt.ad) + '</span>' +
        '<span class="en-dag-bar"><i style="width:' + Math.max(2, x.yuzde) + '%;--r:' + tt.renk + '"></i></span>' +
        '<span class="en-dag-v">' + x.yuzde + '</span></div>';
    });
    dagIc += '</div>' + derin('Bu yüzdeler nasıl hesaplandı?',
      '<p>45 maddenin her biri bir tipe ait. Ama ham toplam kullanılmıyor: bazı insanlar her maddeye yüksek, ' +
      'bazıları düşük puan verir (buna <em>yanıt eğilimi</em> denir) ve ham toplamda cömert cevaplayanın bütün ' +
      'tipleri yükselir, ayrım kaybolur.</p>' +
      '<p>Bu yüzden puanların <strong>kendi ortalamana ve dağılımına göre</strong> standartlaştırıldı ' +
      '(ipsatif z-skor). Yani soru şu değil: “bu maddelere ne kadar katılıyorsun?” — şu: ' +
      '“<strong>kendi içinde</strong> hangi kalıba daha çok meylediyorsun?”</p>' +
      '<p>Yüzdeler mutlak bir ölçü değil, senin içindeki sıralamayı okunur kılan bir gösterimdir.</p>');
    h += bolum('enDag', 'Dokuz eğilimin', 'Tip Dağılımın', dagIc);

    /* ---- 10 · taşlar + ürünler ---- */
    var tasIc = '<p class="en-giris">Enneagram’ın taş geleneği yok; bu yüzden eşleştirmeyi <strong>tipin ihtiyacı</strong> ' +
      'üzerinden yaptım. Senin dönüşüm yönün ' + esc(T.cakraAd) + ' merkezi — ' + esc(T.cakraNeden) + '.</p>' +
      '<div class="en-taslar">';
    T.taslar.forEach(function (x) { tasIc += '<div class="en-tas">' + esc(x) + '</div>'; });
    tasIc += '</div>';
    h += bolum('enTas', 'Dönüşüm yönün', T.cakraAd + ' Merkezi', tasIc);

    var uIc = '';
    var u1 = urunler(T.cakra, 4, 'Tip ' + s.anaTip);
    if (u1) uIc += '<div class="en-ug"><h4>' + esc(T.cakraAd) + ' — en çok burada zorlanıyorsun</h4>' +
      '<p class="en-ug-alt">' + esc(T.ders) + '</p>' + u1 + '</div>';

    var mCakra = { beden: 'kok-cakrasi', kalp: 'kalp-cakrasi', zihin: 'ucuncu-goz-cakrasi' };
    var mKey = Object.keys(M.MERKEZ).filter(function (k) { return M.MERKEZ[k].tipler.indexOf(s.anaTip) > -1; })[0];
    if (mCakra[mKey] !== T.cakra) {
      var u2 = urunler(mCakra[mKey], 4, s.merkez.ad + ' merkezi');
      if (u2) uIc += '<div class="en-ug"><h4>' + esc(s.merkez.ad) + ' merkezini dengele</h4>' +
        '<p class="en-ug-alt">Merkezinin duygusu ' + esc(mk.duygu.toLocaleLowerCase('tr')) + '; bu merkezi ' +
        'destekleyen taşlar dengeni korumana yardım eder.</p>' + u2 + '</div>';
    }
    var bT = I.TIP[s.buyumeOk];
    if (bT.cakra !== T.cakra && bT.cakra !== mCakra[mKey]) {
      var u3 = urunler(bT.cakra, 4, 'Büyüme yönün · ' + s.buyumeOk);
      if (u3) uIc += '<div class="en-ug"><h4>Büyüme okun: Tip ' + s.buyumeOk + '</h4>' +
        '<p class="en-ug-alt">' + esc(I.OK_BUYUME[s.anaTip]) + '</p>' + u3 + '</div>';
    }
    if (uIc) h += bolum('enUrun', 'Zorlandığın yer', 'Tipinin en çok zorlandığı yanı destekle', uIc);

    /* ---- 11 · kendin tasarla ---- */
    h += '<div class="en-kt"><div class="en-kt-ic">' +
      '<span class="en-kt-ust">Kendi tasarımın</span>' +
      '<h3>Bu taşlarla kendi bilekliğini tasarla</h3>' +
      '<p>' + esc(T.taslar.join(', ')) + ' taşlarını tek bir bileklikte birleştirebilirsin. ' +
      'Taşları sen seçersin, biz sana özel üretiriz.</p>' +
      '<a class="en-kt-btn" href="/pages/kendin-tasarla">Kendin Tasarla →</a></div></div>';

    /* ---- 12 · kapanış ---- */
    h += '<div class="en-son">' +
      '<div class="en-eposta" id="enEpostaKutu">' +
        '<h4>Analizini e-posta ile gönderelim</h4>' +
        '<p>Tipin, kanadın, okların ve sana seçilen taşlar tek bir e-postada dursun.</p>' +
        '<div class="en-eposta-row">' +
          '<input type="email" id="enEpostaAdres" placeholder="e-posta adresin" value="' + esc(D.email) + '" autocomplete="email">' +
          '<button type="button" id="enEpostaGonder">Gönder</button>' +
        '</div><div class="en-eposta-durum" id="enEpostaDurum" hidden></div>' +
      '</div>' +
      '<div class="en-son-btns">' +
        '<button type="button" class="en-btn-alt" id="enTekrar">Testi Yeniden Yap</button>' +
        '<button type="button" class="en-btn-alt" id="enPaylas">Paylaş</button>' +
      '</div>' +
      '<p class="en-disclaimer">Enneagram bir kişilik ve kendini tanıma modelidir; klinik tanı aracı değildir, ' +
      'tıbbi veya psikiyatrik değerlendirmenin yerine geçmez. Sonuç senin yanıtlarına dayanır — ' +
      'kendini en iyi tanıyan sensin, test yalnızca bir ayna.</p></div>';

    kap.innerHTML = h;

    /* 3B bileşenler */
    if (S) {
      if (sembol) sembol.durdur();
      sembol = S.enneagram($('#enSembol', kap), {
        anaTip: s.anaTip, kanat: s.kanat.kanat,
        stresOk: s.stresOk, buyumeOk: s.buyumeOk,
        renkler: tipRenkleri()
      });
      if (merkezKure) merkezKure.durdur();
      merkezKure = S.merkezler($('#enMerkez', kap), {
        kume: [
          { k: 'zihin', ad: 'Zihin', deger: mAgirlik.zihin / mTop, renk: '#5f86e0' },
          { k: 'kalp',  ad: 'Kalp',  deger: mAgirlik.kalp / mTop,  renk: '#f0919b' },
          { k: 'beden', ad: 'Beden', deger: mAgirlik.beden / mTop, renk: '#63b487' }
        ]
      });
    }

    urunOlaylari(kap);
    $('#enTekrar', kap).addEventListener('click', function () {
      if (sembol) { sembol.durdur(); sembol = null; }
      if (merkezKure) { merkezKure.durdur(); merkezKure = null; }
      etiketYazildi = false;
      D.cevap = {}; D.sayfa = 0;
      ekran('gate'); girisSembolBasla();
    });
    $('#enPaylas', kap).addEventListener('click', paylas);
    $('#enEpostaGonder', kap).addEventListener('click', epostaGonder);
  }

  /* ---------------------------------------------------------- paylaş */
  function paylas() {
    var s = D.sonuc, T = I.TIP[s.anaTip];
    var metin = 'Enneagram sonucum: Tip ' + s.anaTip + ' — ' + T.ad + ' (' + s.kanat.etiket + '). Sen de bak:';
    var url = location.origin + location.pathname;
    if (navigator.share) navigator.share({ title: 'Enneagram Analizi', text: metin, url: url }).catch(function () { });
    else if (navigator.clipboard) {
      navigator.clipboard.writeText(metin + ' ' + url).then(function () {
        var b = $('#enPaylas', kok);
        if (b) { b.textContent = 'Kopyalandı ✓'; setTimeout(function () { b.textContent = 'Paylaş'; }, 2000); }
      }).catch(function () { });
    }
  }

  /* ---------------------------------------------------------- e-posta */
  function epostaGonder() {
    var adres = ($('#enEpostaAdres', kok).value || '').trim();
    var durum = $('#enEpostaDurum', kok), btn = $('#enEpostaGonder', kok);
    durum.hidden = false; durum.className = 'en-eposta-durum';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(adres)) {
      durum.classList.add('is-hata'); durum.textContent = 'Geçerli bir e-posta adresi yazar mısın?'; return;
    }
    if (!VERI.eposta) {
      durum.classList.add('is-hata'); durum.textContent = 'E-posta servisi şu an kapalı, kısa süre sonra tekrar dene.'; return;
    }
    D.email = adres;
    btn.disabled = true; btn.textContent = 'Gönderiliyor…'; durum.textContent = '';

    fetch(VERI.eposta, {
      method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(epostaGovdesi(adres))
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) {
        btn.disabled = false; btn.textContent = 'Gönder';
        if (j && j.ok) {
          durum.classList.add('is-ok');
          durum.textContent = 'Gönderildi ✓  ' + adres + ' adresini kontrol et.';
          panelKaydet();
        } else {
          durum.classList.add('is-hata');
          durum.textContent = (j && j.mesaj) || 'Gönderilemedi, biraz sonra tekrar dener misin?';
        }
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Gönder';
        durum.classList.add('is-hata'); durum.textContent = 'Bağlantı kurulamadı, biraz sonra tekrar dene.';
      });
  }

  function epostaGovdesi(adres) {
    var s = D.sonuc, T = I.TIP[s.anaTip];
    function urunSec(handle, adet) {
      return (URUN[handle] || []).slice(0, adet || 2).map(function (x) {
        return { t: x.t, u: location.origin + x.u,
                 g: (x.g || '').replace(/^\/\//, 'https://'), f: paraFmt(x.f, PARA) };
      });
    }
    return {
      test_kod: D.testId, tur: 'enneagram', email: adres, ad: D.ad,
      tip: s.anaTip, tip_ad: T.ad, tip_unvan: T.unvan, tip_oz: T.oz, tip_metin: T.uzun,
      renk: T.renk, kanat: s.kanat.etiket, kanat_metin: T.kanat[s.kanat.kanat].m,
      korku: T.korku, arzu: T.arzu, tutku: T.tutku, erdem: T.erdem, ders: T.ders,
      guc: T.guc, golge: T.golge,
      merkez: s.merkez.ad, merkez_duygu: s.merkez.duygu,
      stres_ok: s.stresOk, stres_metin: I.OK_STRES[s.anaTip],
      buyume_ok: s.buyumeOk, buyume_metin: I.OK_BUYUME[s.anaTip],
      icgudu: I.ICGUDU_METIN[s.icgudu.baskin].ad,
      alt_tip_ad: T.alt[s.icgudu.baskin].ad, alt_tip_metin: T.alt[s.icgudu.baskin].m,
      karsi_tip: s.karsiTipMi,
      taslar: T.taslar, cakra: T.cakraAd,
      urunler: urunSec(T.cakra, 4),
      kendin_tasarla: location.origin + '/pages/kendin-tasarla',
      sayfa: location.origin + location.pathname
    };
  }

  ekran('gate');
})();
